import { useEffect, useState } from "react";
import { Clock, RotateCw } from "lucide-react";
import httpClient from "../../../custom-hooks/httpClient";
import { useSelector } from "react-redux";


export function ResendCode() {
  const [isResending, setIsResending] = useState(false);
  const [isResendAllowed, setIsResendAllowed] = useState(false);
  const [timeLeft, setTimeLeft] = useState(parseInt(process.env.REACT_APP_OTP_TIMER));
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    let timer;
    if (!isResendAllowed && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTimeLeft) => {
          if (prevTimeLeft === 1) {
            clearInterval(timer);
            setIsResendAllowed(true);
          }
          return prevTimeLeft - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isResendAllowed, timeLeft]);

  const handleResendOTP = async () => {
    if (isResending) return;
    setIsResending(true);
    try {
      const { status } = await httpClient.get(`/auth/get-otps?phone_number=${user.phone_number}`);
      if (status === 200) {
        setIsResendAllowed(false);
        setTimeLeft(parseInt(process.env.REACT_APP_OTP_TIMER)); // Reset timer.
        setErrorMessage(null);
        setSuccessMessage("OTP has been resent successfully!");
        setTimeout(() => {
          setSuccessMessage(null);
        }, 5000); // Clear success message after 5 seconds.
      }
    } catch (error) {
      // console.error("Error resending OTP:", error);
      setErrorMessage("Failed to resend OTP! Please try again.");
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000); // Clear error message after 5 seconds.
    }
    setIsResending(false);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = String(timeLeft % 60).padStart(2, "0");

  return (
    <div className="text-center" style={{ fontSize: "0.82rem" }}>
      {errorMessage && (
        <div
          className="alert alert-danger text-center mb-3"
          role="alert"
          style={{
            background: "#f8d7da",
            borderColor: "#f5c6cb",
            color: "#721c24",
          }}
        >
          {errorMessage}
        </div>
      )}
      {successMessage && (
        <div
          className="alert alert-primary text-center mb-3"
          role="alert"
          style={{
            background: "#d4edda",
            borderColor: "#c3e6cb",
            color: "#155724",
          }}
        >
          {successMessage}
        </div>
      )}
      {isResendAllowed ? (
        <span className="text-muted">
          Didn&apos;t get the code?{" "}
          <button
            type="button" 
            onClick={handleResendOTP}
            className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1 align-baseline"
            style={{ fontSize: "0.82rem", fontWeight: 600, color: "#0F5C30" }}
            disabled={isResending}
          >
            <RotateCw size={13} />
            {isResending ? "Resending…" : "Resend code"}
          </button>
        </span>
      ) : (
        <span className="text-muted d-inline-flex align-items-center gap-1">
          <Clock size={14} />
          Resend code in {minutes}m : {seconds}s
        </span>
      )}
    </div>
  );
}